module.exports = __webpack_public_path__ + "img/error.99d3fdf0.svg";